import OEMainMenuBtnAdapter from './oe-main-menu-btn-adapter';
import OELicensingAccessTool from '../../../../react-oe/oe-licensing-access-tool';
import {OEFeature} from '../../../../react-oe/oe-types';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import OENotification from '../../../../lib/notification/oe-notification';
import { OETarget } from '../../../../react-oe/oe-target';

export default class OEMainMenuBtnAdapterMediaCenterDisableNoLicense extends OEMainMenuBtnAdapter {

    constructor(availableForHelpTarget = true) {
        super();

        this.availableForHelpTarget = availableForHelpTarget;

        this.available = true;

        this.state = {
            active: false,
            enabled: false,
            featureAvailable: true,
            licensingAccessible: true
        };

        this.connected = false;

        this.onMediaCenterDirectPlayChanged = this.onMediaCenterDirectPlayChanged.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);
        this.onFeatureAccessChanged = this.onFeatureAccessChanged.bind(this);
        this.onLicensingProductActivationChanged = this.onLicensingProductActivationChanged.bind(this);
    }

    setState(state) {
        let newState = Object.assign({}, this.state, state);
        if(OEToolbox.shallowEqual(newState, this.state, true)) return;
        this.state = newState;
        if(this.menu) this.menu.updateForAdapter(this);
    }

    onConnect(oe, menu)  {
        this.connected = true;
        this.updateState(menu);
        menu.props.appComponent.uiLayer.notificationCenter.register(OENotification.mediaCenterDirectPlayChanged, this.onMediaCenterDirectPlayChanged);
        oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
        oe.sharedNotificationCenter.register(this.oe.NotificationName.featureAccessChanged, this.onFeatureAccessChanged);
        oe.sharedNotificationCenter.register(this.oe.NotificationName.licensingProductActivationChanged, this.onLicensingProductActivationChanged);
    }

    onRelease(oe, menu)  {
        this.connected = false;
        menu.props.appComponent.uiLayer.notificationCenter.unregister(OENotification.mediaCenterDirectPlayChanged, this.onMediaCenterDirectPlayChanged);
        oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
        oe.sharedNotificationCenter.unregister(this.oe.NotificationName.featureAccessChanged, this.onFeatureAccessChanged);
        oe.sharedNotificationCenter.unregister(this.oe.NotificationName.licensingProductActivationChanged, this.onLicensingProductActivationChanged);
        this.updateState(menu);
    }

    onMediaCenterDirectPlayChanged()    {
        this.updateState();
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type === this.oe.Module.UIControllerType.media_center) {
            this.updateState();
        }
    }

    onFeatureAccessChanged(message, userInfo)    {
         this.updateState();
    }

    onLicensingProductActivationChanged(message, userInfo)    {
         this.updateState();
    }

    updateState(menu)   {
        menu = menu || this.menu;
        const licensingAccess = OELicensingAccessTool.getLicensingAccess(this.oe, !this.connected);
        const connected = this.oe && this.oe.isReady() && this.connected;

        //
        let available = !licensingAccess.isLicensing || licensingAccess.isValid || (this.availableForHelpTarget && connected && this.oe.sharedInterface.getUIControllerApp().getTarget() === OETarget.effigosExplorerHelp);

        //
        let featureAvailable = false;
        if(connected)   {
            let featureSet = this.oe.sharedInterface.getUIControllerFeatureAccess().getFeatureSet();
            featureAvailable = featureSet.hasFeature({value: OEFeature.media});
            featureSet.delete();
        }

        //
        let uiVisible = false, uiPresentable = false;
        if(connected)   {
            uiVisible = this.oe.sharedInterface.getUIControllerMediaCenter().getUIVisible();
            uiPresentable = this.oe.sharedInterface.getUIControllerMediaCenter().getUIPresentable();
        }

        //
        let mediaCenterDirectPlay = true;
        if(menu && menu.props.appComponent.mediaCenter)    {
            mediaCenterDirectPlay = menu.props.appComponent.mediaCenter.getDirectPlay().enabled;
        }

        //
        let enabled = uiPresentable && (available || (uiVisible && !mediaCenterDirectPlay));

        this.setState({
            active: enabled && uiVisible,
            enabled: enabled,
            featureAvailable: enabled || (available && featureAvailable),
            licensingAccessible: enabled || available
        });

        //
        if(this.available != available) {
            this.available = available;
            this.onAvailableChanged(menu);
        }
    }

    onAvailableChanged(menu)    {
        menu = menu || this.menu;
        const connected = this.oe && this.oe.isReady() && this.connected;
        if(!connected)  return;

        let uiVisible = this.oe.sharedInterface.getUIControllerMediaCenter().getUIVisible();

        let mediaCenterDirectPlay = true;
        if(menu && menu.props.appComponent.mediaCenter)    {
            mediaCenterDirectPlay = menu.props.appComponent.mediaCenter.getDirectPlay().enabled;
        }

        if(!this.available && uiVisible && !mediaCenterDirectPlay)  {
            this.oe.sharedInterface.getUIControllerMediaCenter().setUIVisible(false);
        }
    }

    onPressed(activated, menu)   {
        menu.onMediaCenterBtnPressed();
        return this.state.active;
    }

    isActive(menu)   {
        return this.state.active;
    }

    isEnabled(menu) {
        return this.state.enabled;
    }

    isFeatureAvailable(menu) {
        return this.state.featureAvailable;
    }

    isLicensingAccessible(menu)    {
        return this.state.licensingAccessible;
    }
}